//@ts-nocheck
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ApiError, DepartmentResponse, TeamMessagesResponse, TeamsState } from './messageType';
import {
    createTeamMessage, deleteTeamMemberMessage,
    fetchTeamMessagesList, updateTeamMessage
} from '../../../services/messageService';


export const createTeamMessageThunk = createAsyncThunk<DepartmentResponse, { formData: FormData }, { rejectValue: string }>(
    'teamMessages/create',
    async ({ formData }, { rejectWithValue }) => {
        try {
            const response = await createTeamMessage({ formData });
            return response;
        } catch (err) {
            return rejectWithValue('Failed to create team message');
        }
    }
);

export const fetchTeamMessagesListThunk = createAsyncThunk<
    TeamMessagesResponse,
    { jobId: string; appID: string; page: number; limit?: number; type?: string; privacy?: string; user_type?: string; status?: string },
    { rejectValue: string }>(
    'fetchTeamMessagesList/fetch',
    async ({ jobId, appID, page, limit = 25, type, privacy, user_type, status }, { rejectWithValue }) => {
        try {
            const response = await fetchTeamMessagesList({ jobId, appID, page, limit, type, privacy, user_type, status });
            return response;
        } catch (err) {
            const error = err as ApiError;
            return rejectWithValue(error.response?.data?.message || 'Failed to fetch team messages');
        }
    }
);


export const updateTeamMessageAsync = createAsyncThunk<
    DepartmentResponse,
    { baseId: number; id: number; messageContent: string },
    { rejectValue: string }
>(
    'updateTeamMessage/fetch',
    async ({ id, messageContent }, { rejectWithValue }) => {
        try {
            const response = await updateTeamMessage(id, messageContent);
            return response;
        } catch (err) {
            const error = err as ApiError;
            return rejectWithValue(error.response?.data?.message || 'Failed to update team message');
        }
    }
);


// delete base member status action
export const deleteTeamMemberMessageData = createAsyncThunk<BaseResponse, { id: number }, { rejectValue: string }>(
    'base/deleteTeamMemberMessageData',
    async ({ id, }, { rejectWithValue }) => {
        try {
            const response = await deleteTeamMemberMessage(id);
            return response;
        } catch (err) {
            const error = err as ApiError;
            return rejectWithValue(error.response?.data?.message || 'Failed to delete base member');
        }
    }
);



// Initial state
const initialState: TeamsState = {
    createTeamMessageStatus: 'idle',
    createTeamMessageError: null,
    createTeamMessageData: null,
    fetchTeamMessagesStatus: 'idle',
    fetchTeamMessagesError: null,
    fetchTeamMessagesData: null,
    updateTeamMessageStatus: 'idle',
    updateTeamMessageError: null,
    updateTeamMessageData: null,
    deleteTeamMemberMessageStatus: 'idle',
    deleteTeamMemberMessageError: null,
    deleteTeamMemberMessageData: null

};

const messageSlice = createSlice({
    name: 'Message',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(createTeamMessageThunk.pending, (state) => {
                state.createTeamMessageStatus = 'loading';
                state.createTeamMessageError = null;
            })
            .addCase(createTeamMessageThunk.fulfilled, (state, action) => {
                state.createTeamMessageStatus = 'succeeded';
                state.createTeamMessageData = action.payload;
                state.createTeamMessageError = null;
            })
            .addCase(createTeamMessageThunk.rejected, (state, action) => {
                state.createTeamMessageStatus = 'failed';
                state.createTeamMessageError = action.payload || 'Failed to create team message';
            })
            .addCase(fetchTeamMessagesListThunk.pending, (state) => {
                state.fetchTeamMessagesStatus = 'loading';
                state.fetchTeamMessagesError = null;
            })
            .addCase(fetchTeamMessagesListThunk.fulfilled, (state, action) => {
                state.fetchTeamMessagesStatus = 'succeeded';
                state.fetchTeamMessagesData = action.payload;
                state.fetchTeamMessagesError = null;
            })
            .addCase(fetchTeamMessagesListThunk.rejected, (state, action) => {
                state.fetchTeamMessagesStatus = 'failed';
                state.fetchTeamMessagesError = action.payload || 'Failed to fetch team messages';
            })
            .addCase(updateTeamMessageAsync.pending, (state) => {
                state.updateTeamMessageStatus = 'loading';
                state.updateTeamMessageError = null;
            })
            .addCase(updateTeamMessageAsync.fulfilled, (state, action) => {
                state.updateTeamMessageStatus = 'succeeded';
                state.updateTeamMessageData = action.payload;
                state.updateTeamMessageError = null;
            })
            .addCase(updateTeamMessageAsync.rejected, (state, action) => {
                state.updateTeamMessageStatus = 'failed';
                state.updateTeamMessageError = action.payload || 'Failed to update team message';
            })
            .addCase(deleteTeamMemberMessageData.pending, (state) => {
                state.deleteTeamMemberMessageStatus = 'loading';
                state.deleteTeamMemberMessageError = null;
            })
            .addCase(deleteTeamMemberMessageData.fulfilled, (state, action) => {
                state.deleteTeamMemberMessageStatus = 'succeeded';
                state.deleteTeamMemberMessageData = action.payload;
                state.deleteTeamMemberMessageError = null;
            })
            .addCase(deleteTeamMemberMessageData.rejected, (state, action) => {
                state.deleteTeamMemberMessageStatus = 'failed';
                state.deleteTeamMemberMessageError = action.payload || 'Failed to delete base member';
            })
    },
});

export default messageSlice.reducer;
